"use client";

import Button from "./Button";
import CareerTeaser from "./CareerTeaser.js";
import Carousel from "./Carousel.js";
import CustomerLogoCarousel from "./CustomerLogoCarousel.js";
import Hero from "./Hero.js";
import Layout from "./Layout.js";
import NewsletterTeaser from "./NewsletterTeaser.js";
import OpenSourceTeaser from "./OpenSourceTeaser.js";
import FrontpageList from "./FrontpageList.js";
import { useI18n } from "../lib/i18n";

export default function Frontpage({ customers, items, slides }) {
  const { t } = useI18n();
  return (
    <Layout
      description={t("aboutTeaser.text")}
      shareImg={(slides && slides[0]?.image) || null}
    >
      <Carousel slides={slides} />
      <div className="relative">
        <Hero title={t("aboutTeaser.title")}>
          <p className="my-4 lg:my-8">{t("aboutTeaser.text")}</p>
          <Button href="/about">{t("website.more")}</Button>
        </Hero>
        <FrontpageList items={items} />
        <OpenSourceTeaser />
        <CareerTeaser />
        <NewsletterTeaser />
        <h2 className="break-words text-5xl text-center mt-8">
          {t("frontpage.customers")}
        </h2>
        <CustomerLogoCarousel customers={customers} />
      </div>
    </Layout>
  );
}
